const getters = {
  getAvailableContractorTelegrams: state => state.availableContractorTelegrams,
  getContractorTelegrams: state => state.contractorTelegrams,
  getContractorTelegramCampaigns: state => state.contractorTelegramCampaigns,
  getAvailablePartnerTelegrams: state => state.availablePartnerTelegrams,
  getPartnerTelegrams: state => state.partnerTelegrams,
  getPartnerTelegramCampaigns: state => state.partnerTelegramCampaigns
}

const actions = {
  setAvailableContractorTelegrams ({ commit }, data) {
    commit('setAvailableContractorTelegrams', data)
  },
  setContractorTelegrams ({ commit }, data) {
    commit('setContractorTelegrams', data)
  },
  setContractorTelegramCampaigns ({ commit }, data) {
    commit('setContractorTelegramCampaigns', data)
  },
  setAvailablePartnerTelegrams ({ commit }, data) {
    commit('setAvailablePartnerTelegrams', data)
  },
  setPartnerTelegrams ({ commit }, data) {
    commit('setPartnerTelegrams', data)
  },
  setPartnerTelegramCampaigns ({ commit }, data) {
    commit('setPartnerTelegramCampaigns', data)
  }
}

const mutations = {
  setAvailableContractorTelegrams (state, data) {
    state.availableContractorTelegrams = data
  },
  setContractorTelegrams (state, data) {
    state.contractorTelegrams = data
  },
  setContractorTelegramCampaigns (state, data) {
    state.contractorTelegramCampaigns = data
  },
  setAvailablePartnerTelegrams (state, data) {
    state.availablePartnerTelegrams = data
  },
  setPartnerTelegrams (state, data) {
    state.partnerTelegrams = data
  },
  setPartnerTelegramCampaigns (state, data) {
    state.partnerTelegramCampaigns = data
  }
}

const state = {
  availableContractorTelegrams: {},
  contractorTelegrams: {},
  contractorTelegramCampaigns: {},
  availablePartnerTelegrams: {},
  partnerTelegrams: {},
  partnerTelegramCampaigns: {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
